module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/DVD-d44edfc061357ef3856ee2fbf57eff21.svg";